/*
 * provaActionReducer
 * Description
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 * @version 1.0.0
 * @author Giuseppe
 * @since 12-Oct-2022
 */
import produce from 'immer';
import { actionTypes } from '../actions/portalModalActions';

const ACTION_HANDLERS = {
  [actionTypes.FLOW_POPUP]: produce((draft, action) => {
    draft.flowPopup = action.payload.popup;
    draft.data = action.payload.moreInfo;
  }),
};

// The initial state of the provaAction
const initialState = {
  flowPopup: '',
  data: {},
};

const portalModalAction = (state = initialState, action) => {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
};

export default portalModalAction;
